import clsx from 'clsx'

import {cssTheme} from '../theme'
import {css} from '../theme/css'

const dividerClass = css`
  border-bottom: 1px solid ${cssTheme.default.day.line};
`

export const Divider = ({className, ...props}: JSX.IntrinsicElements['div']) => (
  <div className={clsx(className, dividerClass)} {...props} />
)
